import { NgModule } from "@angular/core";
import { DiaryHomeComponent } from "./diary-home/diary-home.component";
import { DiaryRoutingModule } from "@app/view/diary/diary-routing.module";
import { SharedModule } from "@app/view/shared";
import { DiaryViewerComponent } from "@app/view/diary/diary-viewer/diary-viewer.component";
import { DiaryDayViewComponent } from "./diary-day-view/diary-day-view.component";
import { DiaryWeekViewComponent } from "./diary-week-view/diary-week-view.component";
import { DiaryService } from "@app/view/diary/diary-service/diary.service";
import { AvailabilityEditorComponent } from "./availability-editor/availability-editor.component";
import { DiaryManagementComponent } from "./diary-management/diary-management.component";
import { AvailabilityDeleteConfirmDialogComponent } from "./availability-delete-confirm-dialog/availability-delete-confirm-dialog.component";
import { BulkAvailabilityWizardComponent } from "@app/view/diary/bulk-availability-wizard/bulk-availability-wizard.component";

@NgModule({
  providers: [DiaryService],
  imports: [
    SharedModule,
    DiaryRoutingModule,
    DiaryHomeComponent,
    DiaryViewerComponent,
    DiaryDayViewComponent,
    DiaryWeekViewComponent,
    AvailabilityEditorComponent,
    DiaryManagementComponent,
    AvailabilityDeleteConfirmDialogComponent,
    BulkAvailabilityWizardComponent
  ]
})
export class DiaryModule {}
